import { defineComponent, h } from 'vue'
import { useI18n } from 'vue-i18n'
import { useOptionsFormatter } from '@/composables/optionsFormatter'
import ReIcon from '@/elements/ReIcon.vue'

export const registerValuationTypeColumn = (dashboard, { visible } = { visible: true }) => {
  const { t } = useI18n()
  const { valuationTypeOptions } = useOptionsFormatter()

  dashboard.registerCustomColumn({
    name: 'valuation_type',
    label: 'monolith.shared.type',
    component: defineComponent({
      setup(ctx, { attrs }) {
        const value = attrs.value || {}
        return () =>
          h(
            'div',
            {
              class: 'row items-center justify-center no-wrap',
            },
            [
              h(ReIcon, {
                name: `ic-${value.value}`,
                class: 'q-mr-sm',
                size: 'xs',
              }),
              h('span', value.label),
            ]
          )
      },
    }),
    options: {
      format: (valuationType) => ({
        label: t(`value.short.${valuationType}`),
        value: valuationType,
      }),
      isMultiSelect: true,
      selectOptions: valuationTypeOptions,
      visible,
    },
  })
}
